import { Button } from '@mui/material';
import { useReducer } from 'react';

import { Checkbox } from '@/components/Form/Checkbox.tsx';

import { useTranslate } from '@/hooks/useTranslate';

import { User } from '@/types/user';

import { getDataTestId } from '@/utils/browser';

import { ContactDetailCard } from './components/ContactDetailsCard';
import { EmploymentDetailCard } from './components/EmploymentDetailCard';

import {
  ReviewActionBar,
  ReviewPersonalDetailsContainer,
} from './ReviewPersonalDetails.styled';

type ReviewPersonalDetailsProps = {
  onContinue: () => void;
  onUpdate: () => void;
  user?: User;
  isUserInfoComplete: boolean;
  confirmCheckboxVisible?: boolean;
  continueButtonLabel?: string;
};

export const ReviewPersonalDetails = ({
  onContinue,
  onUpdate,
  user,
  isUserInfoComplete = false,
  confirmCheckboxVisible = false,
  continueButtonLabel,
}: Readonly<ReviewPersonalDetailsProps>) => {
  const { t } = useTranslate();

  const [confirmChecked, setConfirmChecked] = useReducer(
    state => !state,
    false,
  );

  if (!user) {
    return null;
  }

  return (
    <ReviewPersonalDetailsContainer>
      <ContactDetailCard user={user} />
      <EmploymentDetailCard user={user} />
      {confirmCheckboxVisible && isUserInfoComplete && (
        <Checkbox
          label={t('reviewPersonalDetails.confirmCheckbox.label')}
          checked={confirmChecked}
          onChange={setConfirmChecked}
        />
      )}
      <ReviewActionBar>
        <Button
          {...getDataTestId(`review-personal-details-update-button`)}
          onClick={onUpdate}
          variant="outlined"
        >
          {t('reviewPersonalDetails.button.update')}
        </Button>
        {isUserInfoComplete && (
          <Button
            {...getDataTestId(`review-personal-details-continue-button`)}
            onClick={onContinue}
            disabled={confirmCheckboxVisible && !confirmChecked}
          >
            {continueButtonLabel ?? t('reviewPersonalDetails.button.continue')}
          </Button>
        )}
      </ReviewActionBar>
    </ReviewPersonalDetailsContainer>
  );
};
